import React, { FC } from 'react';

import { ArticleCardTitleProps } from './model';

export const ArticleCardTitle: FC<ArticleCardTitleProps> = ({ children }) => {
  return <h3 className="article-card__article-title">{children}</h3>;
};

export default ArticleCardTitle;
